import { ACTIONS } from '../actions/login'
import { LOGIN } from '../actions/endpoints'

export const initialState = {
    clientLoginConfig: null,
    getClientLoginConfigLoading: false,
    getClientLoginConfigError: null,

    loginState: LOGIN.NOT_LOGGED,
    email: '',
    password: '',
    phone: '',
    toggleSpinner: false,
}

export default (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.GET_CLIENT_LOGIN_CONFIG.START: {
            return { ...state, getClientLoginConfigLoading: true }
        }
        case ACTIONS.GET_CLIENT_LOGIN_CONFIG.SUCCESS: {
            return { ...state, getClientLoginConfigLoading: false, getClientLoginConfigError: null, clientLoginConfig: action.data }
        }
        case ACTIONS.GET_CLIENT_LOGIN_CONFIG.FAILURE: {
            return { ...state, getClientLoginConfigLoading: false, getClientLoginConfigError: action.error, clientLoginConfig: null }
        }
        case ACTIONS.CLEAR_CLIENT_LOGIN_CONFIG: {
            return { ...state, clientLoginConfig: null }
        }

        case ACTIONS.SET_LOGIN_START:
            return {
                ...state,
                loginState: action.data,
            }

        case ACTIONS.TOGGLE_SPINNER:
            return {
                ...state,
                toggleSpinner: action.data,
            }
        case ACTIONS.SET_LOGIN:
            return {
                ...state,
                email: action.data,
                loginState: LOGIN.LOGGED,
            }

        case ACTIONS.SET_LOGIN_STATE:
            return {
                ...state,
                loginState: action.data,
            }

        case ACTIONS.SET_LOGOUT:
            for (const key in localStorage) {
                if (key.match(/amplify|willExpire|fromDeepLink|cognito|email|microsoft|msal|password|userProfile/gi)) {
                    localStorage.removeItem(key)
                }
            }
            return {
                ...state,
                loginState: LOGIN.NOT_LOGGED,
                email: '',
            }

        case ACTIONS.SET_EMAIL:
            return {
                ...state,
                email: action.data,
            }

        case ACTIONS.SET_PASSWORD:
            return {
                ...state,
                password: action.data,
            }

        case ACTIONS.SET_PHONE:
            return {
                ...state,
                phone: action.data,
            }
        default:
            return state
    }
}
